var _templateObject;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from "react";
import styled from "styled-components";
import { Padding } from "styled-components-spacing";
import Container from "@nib-components/container";
import colors from "@nib-components/colors";
export var SectionBackground;

(function (SectionBackground) {
  SectionBackground["white"] = "white";
  SectionBackground["sneezy"] = "sneezy";
  SectionBackground["sleepy"] = "sleepy";
  SectionBackground["happy"] = "happy";
  SectionBackground["grumpy"] = "grumpy";
  SectionBackground["dopey"] = "dopey";
  SectionBackground["doc"] = "doc";
  SectionBackground["bashful"] = "bashful";
  SectionBackground["william"] = "william";
})(SectionBackground || (SectionBackground = {}));

var backgrounds = ["white", "sneezy", "sleepy", "happy", "grumpy", "dopey", "doc", "bashful", "william"]; // eslint-disable-next-line @typescript-eslint/no-unused-vars

var Wrapper = styled(function (_ref) {
  var background = _ref.background,
      rest = _objectWithoutProperties(_ref, ["background"]);

  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), function (props) {
  return props.background && colors[props.background] || "transparent";
});

var Section = function Section(props) {
  var background = props.background,
      children = props.children,
      otherProps = _objectWithoutProperties(props, ["background", "children"]);

  var key = background;
  var validBackground = SectionBackground[key];
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    background: validBackground
  }, otherProps), /*#__PURE__*/React.createElement(Padding, {
    all: {
      xs: 4,
      md: 6,
      lg: 8
    }
  }, /*#__PURE__*/React.createElement(Container, null, children)));
};

Section.displayName = "Section";
export default Section;